import ApiService from './ApiService.js'
import store from '../store'


export default {
    getHeader(input) {
        let authData = store.getters.authData;
        let token = window.btoa(input ? (input.client + ':' + input.secret) : (authData.client + ':' + authData.secret));
        return {
            "Authorization": "Basic " + token,
            'Content-Type': 'application/x-www-form-urlencoded',
            "Accept": "application/json"
        };
    },
    requestToken(input) {
        store.dispatch('LOGIN', input);
        let header = this.getHeader(input);

        let params = new URLSearchParams();
        params.append('grant_type', 'password');
        params.append('scope', 'read');
        params.append('username', input.username);
        params.append('password', input.password);


        return ApiService().post('api/token', 
        params.toString(),
        { 
            headers: header
        });
    },
    refreshToken() {
        let header = this.getHeader();
        let authData = store.getters.authData;

        let params = new URLSearchParams();
        params.append('grant_type', 'refresh_token');
        params.append('scope', 'read');
        params.append('refresh_token', authData.refresh_token);

        return ApiService().post('api/token', 
        params.toString(),
        { 
            headers: header
        });
    }
}
